
export enum HTTPMethod {
  GET,
  POST,
  DELETE,
  PATCH,
}
